var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStars(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 225,
    height: 188,
    viewBox: "0 0 225 188",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.796 168.18L16.4709 172.282C16.0506 172.801 16.0506 173.543 16.4709 174.062L19.796 178.165L15.6982 174.836C15.1803 174.415 14.4387 174.415 13.9208 174.836L9.823 178.165L13.1481 174.062C13.5684 173.543 13.5684 172.801 13.1481 172.282L9.823 168.18L13.9208 171.509C14.4387 171.93 15.1803 171.93 15.6982 171.509L19.796 168.18Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6186 173.171L15.5075 173.87L14.8093 187.998L14.1112 173.87L0 173.171L14.1112 172.472L14.8093 158.344L15.5075 172.472L29.6186 173.171Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M71.4065 6.04297L69.3627 8.56472C69.1044 8.88345 69.1044 9.33978 69.3627 9.6585L71.4065 12.1803L68.8878 10.134C68.5695 9.87539 68.1137 9.87539 67.7953 10.134L65.2766 12.1803L67.3204 9.6585C67.5787 9.33978 67.5787 8.88345 67.3204 8.56472L65.2766 6.04297L67.7953 8.08921C68.1137 8.34784 68.5695 8.34784 68.8878 8.08921L71.4065 6.04297Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M77.4443 9.11342L68.7709 9.54304L68.3418 18.2269L67.9127 9.54304L59.2393 9.11342L67.9127 8.68381L68.3418 0L68.7709 8.68381L77.4443 9.11342Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M134.144 161.627L130.868 158.348L127.592 161.627L130.868 164.907L134.144 161.627Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M155.789 8.97475L152.513 5.69531L149.237 8.97476L152.513 12.2542L155.789 8.97475Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5259 56.8224L11.2502 53.543L7.97462 56.8224L11.2502 60.1019L14.5259 56.8224Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M204.775 161.627L201.499 158.348L198.223 161.627L201.499 164.907L204.775 161.627Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M215.741 43.4453L212.608 47.3121C212.211 47.8008 212.211 48.5005 212.608 48.9892L215.741 52.856L211.879 49.7183C211.391 49.3218 210.692 49.3218 210.204 49.7183L206.342 52.856L209.476 48.9892C209.872 48.5005 209.872 47.8008 209.476 47.3121L206.342 43.4453L210.204 46.5829C210.692 46.9795 211.391 46.9795 211.879 46.5829L215.741 43.4453Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M224.999 48.1499L211.7 48.8087L211.042 62.1241L210.384 48.8087L197.084 48.1499L210.384 47.4912L211.042 34.1758L211.7 47.4912L224.999 48.1499Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStars);
export default __webpack_public_path__ + "static/media/stars.6ab9e8bc93058c43e9a35090ef21f8ff.svg";
export { ForwardRef as ReactComponent };